import { Observable, ReplaySubject, Subject } from "rxjs";
import * as signalR from '@microsoft/signalr';

import { filter } from "rxjs/operators";
import { ApplicationSettings } from "lib-config";

export class LiveUpdateConnector {
    connection$ = new ReplaySubject<signalR.HubConnection>();
    subscriptionKiller$ = new Subject<string>();
    isConnected = false;
    endpoint: string;

    constructor(private settings: ApplicationSettings, endpoint: string) {
        this.endpoint = endpoint;
    }

    async connect() {
        if(!this.isConnected) {
            this.isConnected = true;
            var options: signalR.IHttpConnectionOptions =  {
                withCredentials: true
            };
            var conn = new signalR.HubConnectionBuilder()
                .withUrl(this.settings.backendUrlReporting + this.endpoint, options)
                .withAutomaticReconnect()
                .build();

            console.log("SignalR CONNECTING...", this.endpoint);

            conn.start()
            .then(() => {
                console.log("SignalR CONNECTED", this.endpoint);
                conn.invoke("connectAsync");
                conn.onreconnected(() => conn.invoke("connectAsync"))
                this.connection$.next(conn);
                this.connection$.complete();
            })
            .catch(err => console.error(err.toString()));
        }
    }

    listenFor<T>(methodName: string, subscriptionId: string) : Observable<T> {
        var observable = new Observable<T>((subscriber) => {
            this.connection$.pipe(filter(x => x !== null)).subscribe(connection => { // as soon as the connection is ready, start receiving
                var onMessageReceived = (data: T) => { 
                    subscriber.next(data);
                }
                connection.on(methodName, onMessageReceived); // start listening for specific signalR updates

                this.subscriptionKiller$.pipe(filter(x => x === subscriptionId)).subscribe(x => { //stop subscriptions that are no longer listend to (and only kill subscriptions related to a specific subscriptionId)
                    connection.off(methodName, onMessageReceived); //whenever we kill the subscription we also need to tell the connection to stop listening for signalR requests
                    subscriber.complete(); 
                });
            });
           
        });
        
        return observable;
    }

    killSubscriptions(subscriptionId: string) {
        this.subscriptionKiller$.next(subscriptionId);
    }
}
